import { NgModule } from '@angular/core';
import { SharedComponent } from './shared.component';
import { LeadsModule } from 'projects/sales/src/app/modules/leads/leads.module';
import { OpportunitiesModule } from 'projects/sales/src/app/modules/opportunities/opportunities.module';
import { UserProfileModule } from 'projects/sales/src/app/modules/user-profile/user-profile.module';
import { ColumnChooserComponent } from 'projects/sales/src/app/shared/components/column-chooser/column-chooser.component';



@NgModule({
  declarations: [
    SharedComponent
  ],
  imports: [
    LeadsModule,
    OpportunitiesModule,
    UserProfileModule,
    // ColumnChooserComponent
  ],
  exports: [
    SharedComponent,
    LeadsModule,
    UserProfileModule,
    OpportunitiesModule,
    // ColumnChooserComponent
  ]
})
export class SharedLibModule { }
